import React from "react";
import "./Search_Closing.scss";

function Search_Closing({modal,search}) {



    return(
        <div className="search-clothing-container">
            <img src="/svg/filter_ico.svg" alt="" onClick={()=>{
                modal()
            }}/>
            <input type="text" name="" id="" onChange={(e)=>{
                search(e.target.value)
            }}/>
            <img src="/svg/search_placeholder.svg" alt=""/>
        </div>
    )
}

export {Search_Closing}
